export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-15.16aeb0a5.svg";